import { useLayoutEffect, useRef } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router';

/**
 * Opens each new page at its top (NPJB-828). The window is the app's scroll container, and
 * the router keeps its offset across navigations, so a link clicked low on one page opened
 * the next one part-way down.
 *
 * Only a PUSH to another pathname resets. A REPLACE is the same page fixing its URL (a draft
 * id, a redirect), a search-only change is a filter or search on the page, and a POP
 * (Back / Forward) is left to the browser — none of those should jump.
 *
 * Not `<ScrollRestoration />`: it resets on every URL change, so each same-page
 * `setSearchParams` would need `preventScrollReset` to keep its place.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const shownPathname = useRef(pathname);

  // A layout effect, so the new page is never painted at the old offset first.
  useLayoutEffect(() => {
    if (shownPathname.current === pathname) return;
    shownPathname.current = pathname;
    if (navigationType === NavigationType.Push) window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
};
